<template>
  <img
    v-if="fetched"
    v-bind:src="face_url"
    :alt="face"
    style="border-radius: 50%"
    :height="height"
    :width="height"
  />
</template>
<script>
import { getStorage, ref, getDownloadURL } from "@firebase/storage";
export default {
  name: "Avatar",
  props: {
    height: String,
  },
  data() {
    return {
      face_url: "",
      fetched: false,
    };
  },
  created() {
    const storage = getStorage();
    const starsRef = ref(storage, "Assets/face.webp");
    getDownloadURL(starsRef).then((url) => {
      this.face_url = url;
      this.fetched = true;
      this.$emit("fetched_avatar_c", true);
    });
  },
};
</script>
